module.exports = __webpack_public_path__ + "static/media/white-lines-bg.8bb5d1c3.svg";